<template>
    <div class="popup" :class="{ active: popupShow }">
        <div class="popup__inner">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>예약변경</h2>
                    <button type="button" class="popup__close" @click="popupBtn"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <div class="item-type2">
                        <div class="item">
                            <h3 class="mt-none mb-none">진료과</h3>
                            <p>{{info.deptNm}}</p>
                        </div>
                        <div class="item">
                            <h3 class="mt-none mb-none">진료의사</h3>
                            <p>{{info.drName}} 교수님</p>
                        </div>
                    </div>

                    <h3>진료일 선택</h3>
                    <div class="month__wrap">
                        <div class="month__calendar type2">
                            <kr_Calendar :classList="classList" @getClass="selectDoctor" @selectDate="selectDate" />

                            <ul class="profile__tit-list">
                                <li class="profile__tit-item">예약마감</li>
                                <li class="profile__tit-item">예약가능</li>
                                <li class="profile__tit-item">선택</li>
                            </ul>
                        </div>
                    </div>

                    <h3 id="item-select">진료시간 선택</h3>
                    <div class="popup-btn-wrap">
                        <!-- 선택시 active -->
                        <template v-for="(time, idx) in timeList" :key="idx">
                            <button type="button" :class="{active: selectedTime.MED_TM === time.MED_TM}" @click="setInfomation(time)">{{ time.MED_TM }}</button>
                        </template>
                    </div>

                    <div class="botton-wrap">
                        <button type="button" class="sub-button c-main" @click="popupBtn">취소</button>
                        <button type="button" class="main-button c-main" @click="reservation">예약변경</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                popupShow: false,
                info: '',
                selectedDoctor: {},
                selectedDate: {},
                selectedTime: {},
                reservationInfo: {},
                classList: [],
                timeList: [],
            }
        },
        components: {
        },
        mounted() {
        },
        methods: {
            init() {
                this.info = ''
                this.selectedDoctor = {}
                this.selectedDate = {}
                this.selectedTime = {}
                this.reservationInfo = {}
                this.classList = []
                this.timeList = []
            },
            popupBtn() {
                this.popupShow = !this.popupShow
                if (this.popupShow) {
                    this.selectDoctor(this.info)
                } else {
                    this.init()
                }
            },
            selectDoctor(doctor, selDt) {
                this.selectedDate = {}
                this.selectedTime = {}

                const deptCd = doctor.mainDeptCd ? doctor.mainDeptCd : doctor.deptCd
                this.selectedDoctor = {}
                this.selectedDoctor.name = doctor.drName
                this.selectedDoctor.deptCd = deptCd
                this.selectedDoctor.drSid = doctor.drSid
                // this.selectedDoctor.fastDt = doctor.fastDt
                // this.selectedDoctor.empId = doctor.empId

                if (!selDt) {
                    const today = new Date()
                    const year = today.getFullYear()
                    const month = ('0' + (today.getMonth() + 1)).slice(-2)

                    selDt = year + month
                }

                this.axios.get(this.api.doctor.schedule,
                    {
                        params: {
                            drSid: doctor.drSid,
                            IN_MED_YM: selDt,
                            deptCd: deptCd,
                        }
                    })
                    .then(res => {
                        const data = res.data
                        const schedule = data.schedule

                        this.classList = []
                        if (schedule && schedule.length > 0) {
                            // schedule 을 반복문으로 돌려서 classList에 넣어준다.
                            for (let i of schedule) {
                                let dayClass = ''

                                if (i.CLNC_YN === 'N' && i.HOLY_YN === 'N' && i.NSP_RSN_TP_CD === 'N') {
                                    if (i.MED_RSV_YN === 'N') {
                                        dayClass = 'end'
                                    } else if (i.MED_RSV_YN === 'Y') {
                                        dayClass = 'possibility'
                                    }
                                }

                                this.classList.push({
                                    text: i.MED_DT.replaceAll('-', ''),
                                    MED_RSV_YN: i.MED_RSV_YN,
                                    HOLY_YN: i.HOLY_YN,
                                    calClass: dayClass
                                })

                            }
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })

            },
            selectDate(date) {
                this.selectedTime = {}
                this.selectedDate = date
                this.axios.get(this.api.appointment.doctorDayTime,
                    {
                        params: {
                            IN_DR_SID: this.selectedDoctor.drSid,
                            IN_MED_DT: date.text,
                            IN_MED_DEPT_CD: this.selectedDoctor.deptCd,
                        }
                    })
                    .then(res => {
                        this.timeList = []

                        if (res.data) {
                            this.timeList = res.data

                            const itemSelect = document.querySelector("#item-select");
                            setTimeout(() => {
                                itemSelect.focus();
                                itemSelect.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start"
                                });
                            }, 100);
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })

            },
            setInfomation(time) {
                const date = String(this.selectedDate.text)
                this.selectedTime = {}
                this.reservationInfo = {}

                const dt = `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`

                this.selectedTime = time
                this.selectedTime.selDt = dt
                this.selectedTime.printDt = `${dt} (${this.$commonUtils.getDayOfWeek(date)}) ${time.MED_TM}`

                this.reservationInfo.IN_MED_DT = this.selectedDate.text
                this.reservationInfo.IN_MED_TM = time.MED_TM.replace(':', '')
                this.reservationInfo.IN_DR_SID = this.selectedDoctor.drSid
                this.reservationInfo.IN_MED_DEPT_CD = this.selectedDoctor.deptCd
                this.reservationInfo.RPY_PACT_ID = this.info.RPY_PACT_ID
            },
            reservation() {
                if (Object.keys(this.reservationInfo).length == 0) {
                    alert('예약정보를 선택해주시길 바랍니다.')
                    return
                }

                if (confirm('예약정보를 변경하시겠습니까?')) {
                    let reservationParam = {
                        "IN_MED_DEPT_CD": this.reservationInfo.IN_MED_DEPT_CD,
                        "IN_MEDR_SID": this.reservationInfo.IN_DR_SID,
                        "IN_MED_DT": this.reservationInfo.IN_MED_DT,
                        "IN_MED_TM": this.reservationInfo.IN_MED_TM,
                        "IN_PACT_ID": this.reservationInfo.RPY_PACT_ID,
                    }

                    this.axios.post(this.api.appointment.reservationChange, reservationParam).then(res => {
                        if (res.data.errormsg) {
                            alert(res.data.errormsg)
                            return
                        }
                        if (res.data.code == 'NO') {
                            alert('예약에 실패했습니다. 다시 시도해주시길 바랍니다.')
                            location.reload()
                            return
                        }

                        // 예약 완료 후 patInfoStore 초기화
                        this.$store.state.patInfoStore = {}

                        const myInfo = this.$store.state.myInfoStore
                        const rplFlag = this.$store.state.reserveStore.reserve.rplFlag
                        this.$store.state.reserveStore.reserve = {
                            patName: myInfo.name,
                            ptNo: myInfo.ptNo,
                            patHpNo: myInfo.hpNo,
                            patEmail: myInfo.email,
                            deptCd: this.selectedDoctor.deptCd,
                            deptName: this.info.deptNm,
                            drName: this.selectedDoctor.name,
                            drSid: this.selectedDoctor.drSid,
                            medDt: this.selectedTime.selDt,
                            medTm: this.selectedTime.MED_TM,
                            RPY_PACT_ID: res.data.result,
                            rplFlag: rplFlag
                        }

                        alert('예약이 완료되었습니다.')
                        this.popupBtn()
                        this.$emit('successReservation')
                    })
                }
            },
        },
        mounted() {


        },
    }
</script>